module.exports = __webpack_public_path__ + "img/device_am21.9318c5b6.png";